import { Cookies } from "../utils/globalImports";

export const isTokenValid = (): boolean => {
  return !!Cookies.get("authToken");
};
